export default __webpack_public_path__ + "static/media/biz-dash-applications.aff83703.png";